import { technicianList } from "constants/technician";

const initialState = {
  technicianList: {},
};

const technician = (state = initialState, action) => {
  switch (action.type) {
    case technicianList:
      return { ...state, technicianList: action.payload };
    default:
      return state;
  }
};

export default technician;